import React, { useEffect, useState, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { useCSVDownloader } from 'react-papaparse';
import jsPDF from "jspdf";
import "jspdf-autotable";
import $ from 'jquery';
import moment from 'moment';
import { FormGroup, Button, Label, Form, Modal, ModalHeader, ModalBody, ModalFooter, Input } from 'reactstrap';
import { exportToCSV, exportToExcel, exportToPDF } from '../utils/Exports';
import formatHeaderName from '../utils/formatHeaderName';
import { parseValue } from '../utils/Common';
import Table from './common/Table';
const common = require('../utils/Common');

function SRRRReport() {
  const [rowData, setRowData] = useState([]);
  const [columnDefs, setColumnDefs] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [updateData, setUpdateData] = useState({
    payment_id: '',
    payment_date: '',
    payment_id_vendor: '',
    date_vendor_payment: '',
    payment_id_others: '',
    date_others_payments: '',
  });
  const [totalRecords, setTotalRecords] = useState(0);
    const [userRights, setUserRights] = useState({view: false, edit: false, delete: false, create: false});
  const navigate = useNavigate();
  const [page, setPage] = useState(1);

  useEffect(() => {
    checkAccess();
  }, []);

  const checkAccess = async () => {
    let rights = await common.checkAccessRights(window.location.pathname);
    if (!rights.view) {
      alert("Access Denied");
      navigate("/");
      return;
    } else {
      setUserRights(rights);
      getReportData();
    }
  }

  const getReportData = async (limit = 10, offset = 0, search = {}, isExport = 0, loader = true, reset = false) => {
    if (reset) {
        setPage(1);
        offset = 0;
    } else {
        setPage(offset / limit + 1);
    }
    var parameters = {
      'source': 'Admin',
      'report_name': 'srrr_reports',
      'start_date': $('#date_from').val(),
      'end_date': $('#date_to').val(),
    };
    if (!isExport) {
      parameters.limit = limit;
      parameters.offset = offset;
    }
    console.log(parameters);
    let response = await common.apiRequest('post', '/reports/get-reports', parameters, loader);
    let data = (response.data && response.data.data) ? response.data.data : [];
    if (isExport) {
      return data.reportData;
    }
    const keysToExclude = ['order_item_id', 'logistics_order_id'];
    const cols = common.getReportColumns(keysToExclude, data.keys, ChangeIntDecimals);
    setColumnDefs(cols);
    setRowData(data.reportData);
    setTotalRecords(data.totalRecords);
  }



  const ChangeIntDecimals = [
    'taxable_bank_charges', 'unit_price', 'tax_invoice_value', 'taxable_value', 'igst', 'cgst', 'sgst', 'utgst', 'cess',
    'shipping_tax_invoice_value', 'shipping_taxable_value', 'sigst', 'scgst', 'ssgst', 'sutgst', 'scess', 'rnote_value',
    'rtaxable_value', 'rigst', 'rcgst', 'rsgst', 'rutgst', 'rcess', 'tcs', 'tigst', 'tcgst', 'tsgst', 'tutgst', 'amount_receipt',
    'bank_charges', 'taxable_bank_charges', 'bigst', 'bcgst', 'bsgst', 'butgst', 'cartage', 'marketing_charges', 'commissions', 'discount',
    'other_charges', 'net_payment_of_supplier', 'net_payment_to_vendor', 'net_payment_of_others', 'gross_profit', 'net_cash_flow',
    'replace_logistics_tsgst', 'replace_logistics_tigst', 'replace_logistics_tcgst', 'replace_logistics_tcs',
    'replace_logistics_sgst', 'replace_logistics_igst', 'replace_logistics_cgst',
    'replace_logistics_bsgst', 'replace_logistics_bigst', 'replace_logistics_bcgst','stcs','stigst','stcgst','stsgst','stutgst','stcess',
    'comissions_supplier','commissions_vendor','comissions_others','comissions','taxable_value','taxable_value','taxable_value','taxable_value',
    'shipping_bsgst','shipping_bigst','shipping_bcgst','shipping_butgst','shipping_taxable_value','shipping_taxable_value','shipping_taxable_value','shipping_taxable_value', 'cancel_note_no'
  ];

  const handleUpdate = async () => {
    if (selectedRows.length !== 1) {
      alert("Please select exactly one row to update");
      return;
    }

    try {
      const parameters = {
        report_name: 'srrr_reports',
        order_item_id: selectedRows[0].order_item_id,
        update_data: {
          payment_id: updateData.payment_id,
          payment_date: updateData.payment_date,
          payment_id_vendor: updateData.payment_id_vendor,
          date_vendor_payment: updateData.date_vendor_payment,
          payment_id_others: updateData.payment_id_others,
          date_others_payments: updateData.date_others_payments,
        }
      };
      const response = await common.apiRequest('post', '/reports/update-report', parameters);

      if (response.data && response.data.code === 'success') {
        alert('Record updated successfully');
        setIsModalOpen(false);
        getReportData(10, (page - 1) * 10, {}, 0, true, false);
      } else {
        alert('Failed to update record');
      }
    } catch (error) {
      console.error('Error updating record:', error);
      alert('Error updating record');
    }
  };
  const excludeFields = ['order_item_id', 'logistics_order_id'];

  const data = rowData.map((row, index) => {
    const newRow = {
      slNo: index + 1
    };
    Object.keys(row)
      .filter(key => !excludeFields.includes(key))
      .forEach(key => {
        newRow[formatHeaderName(key)] = row[key];
      });
    return newRow;
  });

  const handleExportCSV = async () => {
    let data = await getReportData(0, 0, {}, 1);
    exportToCSV(data, 'SRRR Report');
  }

  const handleExportExcel = async () => {
    let data = await getReportData(0, 0, {}, 1);
    exportToExcel(data, 'SRRR Report');
  }

  const handleExportPDF = async () => {
    let data = await getReportData(0, 0, {}, 1);
    exportToPDF(data, 'SRRR Report');
  }
  
  return (
    <>
      <div className="row report-margin">
        <div className='col-md-10'>
          <h3>SRRR Report</h3>
        </div>
        <div className="col-md-12">
          <Form className='row'>
            <FormGroup className='col-md-4 row'>
              <Label className="col-md-2 col-form-label" for="date_from">From:</Label>
              <input type='date' defaultValue={moment().startOf('month').format('YYYY-MM-DD')} onChange={() => getReportData()} className="form-control col-md-5" id="date_from" name="date_from"></input>
            </FormGroup>
            <FormGroup className='col-md-4 row'>
              <Label className=" col-md-2 col-form-label" for="date_to">To:</Label>
              <input type='date' defaultValue={moment().endOf('month').format('YYYY-MM-DD')} onChange={() => getReportData()} className="form-control col-md-5" id="date_to" name="date_to"></input>
            </FormGroup>
          </Form>
        </div>
        {/* <CSVDownloader className="csvDownload"
                    filename={'Srrr report'}
                    data={() => csvData}
                >
                    Download Csv
                </CSVDownloader>
                <button className="btn csvDownload" onClick={exportPDF}>Download pdf</button> */}
        <div>
          <button className='btn button-product' onClick={handleExportCSV}>Export to CSV</button>
          <button className='btn button-product' onClick={handleExportExcel}>Export to Excel</button>
          <button className='btn button-product' onClick={handleExportPDF}>Export to PDF</button>
          {selectedRows.length === 1 && (
            <button
              className='btn button-product'
              onClick={() => setIsModalOpen(true)}
            >
              Update Selected
            </button>
          )}
        </div>
      </div>

      <div className="ag-theme-quartz" style={{ height: 600, width: '100%' }}>
        <Table 
          columns={columnDefs}
          data={rowData}
          totalRecords={totalRecords}
          pageSize={10}
          currentPage={page}
          onPageChange = {(limit, offset, search, reset) =>{
              getReportData(limit, offset, search, 0, true, reset);
          }}
          onSelectionChange={(selected) => {
            console.log('Selected rows:', selected);
          }}
        />
      </div>
      <Modal isOpen={isModalOpen} toggle={() => setIsModalOpen(false)}>
        <ModalHeader toggle={() => setIsModalOpen(false)}>Update Record</ModalHeader>
        <ModalBody>
          <FormGroup>
            <Label for="payment_id">Payment ID</Label>
            <Input
              type="number"
              id="payment_id"
              value={updateData.payment_id}
              onChange={(e) => setUpdateData({ ...updateData, payment_id: e.target.value })}
            />
          </FormGroup>
          <FormGroup>
            <Label for="payment_date">Payment Date</Label>
            <Input
              type="date"
              id="payment_date"
              value={updateData.payment_date}
              defaultValue={moment().endOf('month').format('YYYY-MM-DD')}
              onChange={(e) => setUpdateData({ ...updateData, payment_date: e.target.value })}
            />
          </FormGroup>
          <FormGroup>
            <Label for="payment_id_vendor">Payment Id Vendor</Label>
            <Input
              type="number"
              id="payment_id_vendor"
              value={updateData.payment_id_vendor}
              onChange={(e) => setUpdateData({ ...updateData, payment_id_vendor: e.target.value })}
            />
          </FormGroup>
          <FormGroup>
            <Label for="date_vendor_payment">Date Vendor Payment</Label>
            <Input
              type="date"
              id="date_vendor_payment"
              value={updateData.date_vendor_payment}
              defaultValue={moment().endOf('month').format('YYYY-MM-DD')}
              onChange={(e) => setUpdateData({ ...updateData, date_vendor_payment: e.target.value })} />
          </FormGroup>
          <FormGroup>
            <Label for="payment_id_others">Payment Id Others</Label>
            <Input
              type="number"
              id="payment_id_others"
              value={updateData.payment_id_others}
              onChange={(e) => setUpdateData({ ...updateData, payment_id_others: e.target.value })}
            />
          </FormGroup>
          <FormGroup>
            <Label for="date_others_payments">Date Others Payments</Label>
            <Input
              type="date"
              id="date_others_payments"
              value={updateData.date_others_payments}
              defaultValue={moment().endOf('month').format('YYYY-MM-DD')}
              onChange={(e) => setUpdateData({ ...updateData, date_others_payments: e.target.value })} />
          </FormGroup>

        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={handleUpdate}>Update</Button>
          <Button color="secondary" onClick={() => setIsModalOpen(false)}>Cancel</Button>
        </ModalFooter>
      </Modal>
    </>
  )
}

export default SRRRReport;